/**
 * F2 SPA wiring — feature flag for routing imports through the Azure worker
 * instead of the inline upsert loop. Opt-in via:
 *
 *   localStorage.setItem('repancy:bgImport', '1');
 *
 * Default is off until the operator has actually deployed the dispatcher
 * Function App. ExplorerWindow reads this on every import; toggling it
 * doesn't require a reload.
 *
 * Extracted to a leaf module so vitest can exercise the decision without
 * mounting the full Win95 chrome.
 */

export const BG_IMPORT_LS_KEY = 'repancy:bgImport';

/** Returns true if the user has opted into background imports. */
export function isBgImportEnabled(
  storage: Pick<Storage, 'getItem'> | null = typeof window !== 'undefined'
    ? window.localStorage
    : null,
): boolean {
  if (!storage) return false;
  return storage.getItem(BG_IMPORT_LS_KEY) === '1';
}

/**
 * Build a deterministic idempotency key for a background import. Same
 * inputs → same key, which lets the Convex action's `getImportJobByKey`
 * pre-check dedupe a double-clicked import button. We include `Date.now()`
 * deliberately — the user gets a new job per session-second, not a
 * permanent dedupe on the same drive+matter combination.
 */
export function makeBgImportIdempotencyKey(
  driveId: string,
  matterId: string,
  now: number = Date.now(),
): string {
  return `bg-${driveId}-${matterId}-${now}`;
}
